export const Error = {
  'auth/user-not-found': 'Invalid Email',
  'auth/email-already-exists': 'Email already exists',
  'auth/phone-number-already-exists': 'Phone number already exists',
  'auth/invalid-uid': 'Invalid UID',
  'auth/invalid-password': 'Incorrect passowrd',
  'auth/invalid-email-verified': 'Email is not verified',
  'auth/invalid-email': 'Invalid Email',
  'auth/wrong-password': 'Incorrect passowrd',
  'auth/expired-action-code': 'The action code has expired',
  'auth/email-already-in-use': 'Email already in use',
  'auth/too-many-requests':
    'We have blocked all requests from this device due to unusual activity. Try again later.',
};

export const Message = {
  Email_Not_Verified:
    'Your email address is not verified, Please verify your email by clicking on verify link.',
  Email_Verified_Success:
    'Your Email address was successfully verified. Please login.',
  User_Registered_Success:
    'User registration successfully, Please verify your email address by clicking on verify link.',
};
